import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgGoogle({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <mask id="Google_svg__a" maskUnits="userSpaceOnUse" x={2} y={2} width={20} height={20}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.318 10.182H12v3.864h5.364c-.5 2.454-2.591 3.863-5.364 3.863A5.897 5.897 0 016.09 12 5.897 5.897 0 0112 6.09c1.41 0 2.682.5 3.682 1.32L18.59 4.5C16.818 2.955 14.545 2 12 2 6.455 2 2 6.455 2 12c0 5.546 4.455 10 10 10 5 0 9.546-3.636 9.546-10a8.3 8.3 0 00-.228-1.818z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#Google_svg__a)">
        <path d="M1.09 17.91V6.09l7.728 5.91-7.727 5.908z" fill="#FBBC05" />
      </g>
      <mask id="Google_svg__b" maskUnits="userSpaceOnUse" x={2} y={2} width={20} height={20}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.318 10.182H12v3.864h5.364c-.5 2.454-2.591 3.863-5.364 3.863A5.897 5.897 0 016.09 12 5.897 5.897 0 0112 6.09c1.41 0 2.682.5 3.682 1.32L18.59 4.5C16.818 2.955 14.545 2 12 2 6.455 2 2 6.455 2 12c0 5.546 4.455 10 10 10 5 0 9.546-3.636 9.546-10a8.3 8.3 0 00-.228-1.818z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#Google_svg__b)">
        <path d="M1.09 6.091l7.728 5.91L12 9.226l10.909-1.772V1.09H1.091v5z" fill="#EA4335" />
      </g>
      <mask id="Google_svg__c" maskUnits="userSpaceOnUse" x={2} y={2} width={20} height={20}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.318 10.182H12v3.864h5.364c-.5 2.454-2.591 3.863-5.364 3.863A5.897 5.897 0 016.09 12 5.897 5.897 0 0112 6.09c1.41 0 2.682.5 3.682 1.32L18.59 4.5C16.818 2.955 14.545 2 12 2 6.455 2 2 6.455 2 12c0 5.546 4.455 10 10 10 5 0 9.546-3.636 9.546-10a8.3 8.3 0 00-.228-1.818z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#Google_svg__c)">
        <path d="M1.09 17.91L14.728 7.454l3.591.454 4.591-6.818V22.91H1.091v-5z" fill="#34A853" />
      </g>
      <mask id="Google_svg__d" maskUnits="userSpaceOnUse" x={2} y={2} width={20} height={20}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.318 10.182H12v3.864h5.364c-.5 2.454-2.591 3.863-5.364 3.863A5.897 5.897 0 016.09 12 5.897 5.897 0 0112 6.09c1.41 0 2.682.5 3.682 1.32L18.59 4.5C16.818 2.955 14.545 2 12 2 6.455 2 2 6.455 2 12c0 5.546 4.455 10 10 10 5 0 9.546-3.636 9.546-10a8.3 8.3 0 00-.228-1.818z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#Google_svg__d)">
        <path d="M22.91 22.91L8.817 12 7 10.636l15.91-4.545V22.91z" fill="#4285F4" />
      </g>
    </svg>
  )
}

export default SvgGoogle
